// Every sound of the interactive, in one place for the actions and the EDL
// class alike. The loops (background, idle, fire, thrusters) are started and
// stopped by the code, which also does their fades, so the versions with the
// fades baked in are not used.
export const SOUNDS = {
  background: "audio/edl/background-noise.wav",
  idle: "audio/edl/sound-idle.wav",
  startGame: "audio/edl/start-game.wav",
  rightInput: "audio/edl/right-input.wav",
  wrongInput: "audio/edl/wrong-input.wav",
  goodStep: "audio/edl/good-step.wav",
  wrongStep: "audio/edl/wrong-step.wav",
  fire: "audio/edl/fire-loop.wav",
  thrusters: "audio/edl/thrusters-loop.wav",
  heatShield: "audio/edl/heatshield.wav",
  thrusterDoors: "audio/edl/open-trap-doors.wav",
  landingLegs: "audio/edl/legs-deploying.wav",
  winGame: "audio/edl/win-game.wav"
};
